<template>
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-5 col-lg-4 my-5">
            <div class="card bg-light bg-gradient shadow-lg rounded-4 animate__animated animate__fadeInDown">
               <div class="card-body bg-sa-card-body p-2">

                <!--Addition-->                
            <!-- Unified Alert -->
               <div v-if="showAlert" :class="['alert', `alert-${alertType}`]" role="alert">
                <i class="fa-fw fa me-2"
                   :class="alertType === 'success' ? 'fa-check' : 'fa-times'">
                </i>
                {{ alertMessage }}
              </div>
            <!--End Unified Alert -->
                <!--End Addition-->

                  <h3 class="card-title text-center mb-2">Verify Code</h3>
                  <form id="forgotPasswordForm" autocomplete="off">
                     <h1 v-if="VerifyingCode">
                           <span>{{progressMessage}}</span> <img :src="`/img/progress.gif`" height="15" />
                     </h1>

                     <div class="mb-0">
                        <span>Enter the 6-digit code we just sent to your phone</span>
                       <p>Code will Expire in {{expiry_seconds}} seconds</p>
                        <div class="input-group">
                           <span class="input-group-text d-md-flex"><i class="fa fa-envelope"></i></span>
                           <input v-model="smsdigitcode" @input="handleInputChange" @change="handleInputChange" type="text" class="form-control custom-tooltip-input" placeholder="Enter the 6 Digit SMS Code"   required autocomplete="new-email">
                           <div class="custom-tooltip">Please Enter the 6 Digit SMS Code.<span class="tooltip-arrow"></span></div>
                        </div>
                     </div>
                     <div class="d-flex justify-content-end mb-1">                        
                      
                     </div>
                     <div class="d-grid mb-0">
                        <button @click="submitRecord();" type="button" class="btn btn-primary">
                            {{button_text}}
                        </button>
                     </div>
                  </form>
                  Didn't receive the code? Please log in again<br>
      <router-link to="/">
         <button class="btn btn-lg btn-success pull-left">Click here to Login Again!</button>
      </router-link> 
               </div>
            </div>
         </div>
      </div>
   </div>	
</template>
<script>
   import { computed } from 'vue';
   import axios from 'axios'
   import emitter from '../../../main.js'
   import { mapMutations } from 'vuex';
   import { mapActions } from 'vuex';
   //var Emitter = require('tiny-emitter');
   //var emitter = new Emitter();
   
      export default {
         components: {
         },
         data(){
            return {
                  smsdigitcode: "", 
                  expiry_seconds: localStorage.getItem('expiry_seconds') ||'', 
                  VerifyingCode: false,
                  progressMessage: 'Verifying code! Please wait',
                  showAlert: false,
                  alertType: '', // 'success' or 'danger'
                  alertMessage: '',
                  button_text: 'Verify Code'
            }
         },
         created() {
            //clear after use
            this.startCountdown();
            this.showSuccessBackendMessage();
         },
         destroyed() {
            if (this.countdownInterval) {
               clearInterval(this.countdownInterval); // Clear the interval when the component is destroyed
            }
         },
         methods: {
            ...mapMutations(['setUserDetails','SET_PERMISSIONS','SET_MODULES']),
            ...mapActions(['retriveUserDetails']),
             submitRecord(){
               if (!this.handleBeforeSend()) { return;}
               const formData = new FormData();
               formData.append('smsdigitcode', this.smsdigitcode);
               formData.append('mfa_token', sessionStorage.getItem('mfa_token') || '');
               formData.append('action', 'mfaVerifyCode'); // Indicating the action for PHP
               axios.post('/auth/api_auth.php',formData,{withCredentials: true}).then(response=>{   
               console.log(response.data);         
                  if (response.data.status=='mfaExpired') {
                        this.$mfaRestart(response.data.message);
                  } else if (response.data.status=='success') {
                        this.handleSuccess(response);
                  }else {
                        this.handleError(response);
                  }
               })
               .catch(error=>{
                  this.handleError(error);
               })
            },
            handleBeforeSend(){
               //formValidations
               //const formIsValid = formValidations('#forgotPasswordForm'); 
               const formIsValid = this.$validateForm('#forgotPasswordForm');
               if (!formIsValid) { return; }

               this.VerifyingCode=true;
               this.showAlert = false;
               this.button_text= "Verifying...";
               return true;
            },
            // This method handles the response when the verification is successful
            handleSuccess(response) {
               if (response.data.results.is_locationRequired===1) {
                           this.$checkLocationPermission(this, this.$router, this.$route)
                                .then(() => {
                              if (this.$store.state.latitude===null) {//was updated by checkLocationPermission
                                this.VerifyingCode= false;
                                    return;
                              } else {                                 
                                 this.processData(response);
                              }
                           });                                                     
                        } else {
                              this.processData(response);
                        } 
            },
            // This method handles errors that occur during the verification process
            handleError(error) { 
               //$('#verify_code').text("Verify Code");
                     this.button_text= "Verify Code";
                     this.VerifyingCode=false;
                     this.alertType = 'danger';
                     // Check if there's a response from the server
                      //if (error.response && error.response.data && error.response.data.message) {
                      if (error && error.data && error.data.message) {
                          this.alertMessage = error.data.message;
                      } else {
                          //this.alertMessage = 'An unexpected error occurred.';
                          this.alertMessage = error;
                      }

                     this.showAlert = true;
                     this.$router.push('/mfa-verify-code/');
            },
            processData(response){
                     localStorage.removeItem('expiry_seconds');
                     sessionStorage.removeItem('mfa_token');
                     sessionStorage.removeItem('mfa_phone');
                     sessionStorage.removeItem('mfa_email');
                     localStorage.setItem('jwt', response.data.results.token); 
                     localStorage.setItem('csrf_token', response.data.results.csrf_token);
                     localStorage.setItem('is_locationRequired', response.data.results.is_locationRequired);
                     localStorage.setItem('roles', JSON.stringify(response.data.results.roles));localStorage.setItem('permissions', JSON.stringify(response.data.results.permissions));  
                     this.SET_PERMISSIONS(response.data.results.permissions);
                     this.SET_MODULES(response.data.results.modules || []);               
                     localStorage.setItem('subscription', JSON.stringify(response.data.results.subscription));
                     localStorage.setItem('subscription_permissions', JSON.stringify(response.data.results.subscription_permissions));    
                     localStorage.setItem('first_name', response.data.results.first_name);
                     localStorage.setItem('user_pic', response.data.results.user_pic);
                     localStorage.setItem('company_id', response.data.results.company_id);
                     localStorage.setItem('company_name', response.data.results.company_name);
                     localStorage.setItem('branch_id', response.data.results.branch_id);
                     localStorage.setItem('branch_name', response.data.results.branch_name);
                     localStorage.setItem('loggedIn', true);

                     //store.js also sets below data (repetion but better)
                  const userData = {
                    user: {
                      company_id: response.data.results.company_id,
                      company_name: response.data.results.company_name,
                      branch_id: response.data.results.branch_id,
                      branch_name: response.data.results.branch_name,
                      first_name: response.data.results.first_name,
                      user_pic: response.data.results.user_pic,
                      role_name: response.data.results.role_name || '',
                      tokenExpirationTime: '2025-04-11T12:00:00Z'
                    },
                    token: response.data.results.token
                  };

                  // Commit to Vuex store
                  this.setUserDetails(userData);
                  emitter.emit('OnLogin', true);

                  if (this.verifyJWT()) {
                     this.$router.push('/dashboard/');
                  }

                  this.button_text= "Verify Code";
                  this.VerifyingCode=false;
                  this.alertType = 'success';
                  this.alertMessage = "Successfully verified and logged In!";
                  this.showAlert = true;
            },
            showSuccessBackendMessage(){
               //const message = sessionStorage.getItem('backend_message');
               const backend_message = sessionStorage.getItem('backend_message');
               const backend_alertType = sessionStorage.getItem('backend_alertType');
               if (backend_message && backend_alertType) {
                  this.alertMessage = backend_message;
                  this.alertType = backend_alertType;
                  this.showAlert = true;
                  
                  //clear after use first then call showSuccessBackendMessage
                  sessionStorage.removeItem('backend_message');
                  sessionStorage.removeItem('backend_alertType');
                  //$('.alert-success').show().fadeOut(10000);
                  //$('.alert-success').html(message);
               }
            },
            startCountdown() {
         // Check if expiry_seconds is a valid number and start the countdown
         if (this.expiry_seconds && this.expiry_seconds > 0) {
            this.countdownInterval = setInterval(() => {
               if (this.expiry_seconds > 0) {
                  this.expiry_seconds -= 1;
                  localStorage.setItem('expiry_seconds', this.expiry_seconds); // Save updated seconds in localStorage
               } else {
                  clearInterval(this.countdownInterval); // Stop the countdown when it reaches 0
               }
            }, 1000); // Decrease every 1 second
         }
      },
            handleInputChange(event) {
         // Call the validation function for the specific input field that triggered the event
         //formValidations(event.target);
         this.$validateField(event.target);
       },
            verifyJWT(){
               console.log("Router instance:", this.$router); // Check if it's defined
               return this.$store.dispatch('retriveUserDetails', this.$router);
            }          
         }
      };
</script>